import axios from 'axios';
import { useState } from 'react';

export const useFileDownloader = () => {
  const [loading, setLoading] = useState(false);

  const downloadFile = async (url: string, fileName: string) => {
    setLoading(true);
    try {
      let blobData: Buffer;
      if (url.startsWith('data:')) {
        const checkText = 'base64,';
        const index = url.indexOf(checkText);
        const data = url.slice(index + checkText.length);
        blobData = Buffer.from(data);
      } else {
        const response = await axios.get(url, {
          method: 'GET',
          responseType: 'blob',
        });
        blobData = response.data;
      }

      const windowUrl = window.URL.createObjectURL(
        new Blob([blobData], { type: 'application/octet-stream' })
      );
      const link = document.createElement('a');
      link.href = windowUrl;
      link.setAttribute('download', fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };

  return { downloadFile, loading };
};
